import Icon from '../../Icon';
import * as S from './style';

import { antIcon } from '../Basic';
import { UseAudio } from 'Hooks';

/**
 * Primary UI component for user interaction
 */
const PlaySound = ({
  loading,
  handleClick = () => {},
  disabled,
  audioUrl,
  label,
  fallbackText,
  ...props
}) => {
  const { isLoading, fallbackDisabled, handleAudioClick } = UseAudio({
    audioUrl,
    handleClick,
    fallbackText: typeof fallbackText === 'string' && fallbackText,
  });

  const audioDisabled = disabled || isLoading || fallbackDisabled;

  return (
    <S.PlayButton
      type="button"
      disabled={audioDisabled}
      onClick={handleAudioClick}
      onTouchEnd={handleAudioClick}
      as="button"
      loading={loading}
      aria-disabled={disabled ? 'true' : 'false'}
      {...props}
      aria-label="Play sound"
      data-test-id="play-sound-exercise-button"
    >
      <Icon
        icon={'speaker'}
        disabled={audioDisabled}
        width="32px"
        height="32px"
      />
      {loading && <S.CenterLoading indicator={antIcon} />}
      <S.InnerText>{label || 'Play sound'}</S.InnerText>
    </S.PlayButton>
  );
};

export default PlaySound;
